import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useMemo } from 'react';
import config from 'utils/config';
import useModalQueryParam from 'hooks/useModalQueryParam';
export var defaultHelixMindsetContactFormModalToolDescription = "UI ACTION: Opens the in-app \u201CContact us\u201D modal (contact form widget). Use this tool whenever the user's intent is to contact a human (support, admin, sales) or to escalate/raise a ticket\u2014e.g., \u201Cspeak to a real person,\u201D \u201Ctalk to a human,\u201D \u201Ccontact support,\u201D \u201Craise a ticket,\u201D \u201Ccomplaint,\u201D \u201Cescalate,\u201D \u201Ctalk to sales,\u201D \u201Cbook a call.\u201D Default behavior: If contact intent is present, open the modal first, . Do NOT use when the user only wants instructions (e.g., \u201CWhere is the contact form?\u201D) or explicitly asks not to open anything.";
var description = config.helixMindsetContactFormModalToolDescription || defaultHelixMindsetContactFormModalToolDescription;
export function useMindsetContactFormModalTool() {
  var _useModalQueryParam = useModalQueryParam('contact-form'),
    _useModalQueryParam2 = _slicedToArray(_useModalQueryParam, 2),
    setHasContactFormModal = _useModalQueryParam2[1];
  var tool = useMemo(function () {
    return {
      name: 'open_contact_form_modal',
      description: description,
      runningDescription: 'Opening contact form',
      completedDescription: 'Opened contact form',
      parameters: {
        type: 'object',
        properties: {}
      },
      handler: function () {
        var _handler = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                setHasContactFormModal(true);
                return _context.abrupt("return", {
                  success: true
                });
              case 1:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function handler() {
          return _handler.apply(this, arguments);
        }
        return handler;
      }()
    };
  }, [setHasContactFormModal]);
  return {
    tool: tool
  };
}